import Vue from 'vue'
import Alert from './index.vue'
const AlertContructor = Vue.extend(Alert)
export const cache = new Set()
const confirmDialog = function(message, title, options) {
  let instance
  // 实例化
  if (Object.prototype.toString.call(message) === '[object Object]') {
    instance = new AlertContructor({ data: message })
  } else {
    instance = new AlertContructor({ data: { ...options, message, title }})
  }

  /* return new Promise((resolve, reject) => {
    // 实例化
    const instance = new AlertContructor({ data: options })
    // dom元素渲染完成
    instance.$mount()
    // 手动挂载到body上
    document.body.appendChild(instance.$el)
    instance.handleSure = function() {
      instance.visibleDialog = false
      resolve('确认')
    }
    instance.handleClose = function() {
      instance.visibleDialog = false
      reject('取消')
    }
  })*/
  // dom元素渲染完成
  instance.$mount()
  // 手动挂载到body上
  document.body.appendChild(instance.$el)
  return instance.show(vm => { // 显示弹窗
    instance = null // 将实例对象清空
  })
}

export default confirmDialog

